import React, { Component } from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
//import GoogleMapReact from 'google-map-react';
import { config } from "../../Config";
//import Utility from '../../Utility';
//import { List } from 'semantic-ui-react'
import './Gmap.css';
//import useResponsive from "../../hooks/useResponsive";
//import { connect } from "react-redux"

const style = {
  width: '100%',
  height: '100%'
}

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '100%'
}



export class MapContainer extends Component {

    //https://dev.to/jessicabetts/how-to-use-google-maps-api-and-react-js-26c2
    //https://openbase.com/js/google-maps-react
    //https://developers.google.com/maps/documentation/javascript/reference/map#Map.fitBounds

    constructor(props) {
        super(props);
        // Don't call this.setState() here!

        //const { isMobile, isTablet } = useResponsive();

        this.state = { 
            filtredEstablishments: props.filtredEstablishments,
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            google: this.props.google,
            myBounds: new this.props.google.maps.LatLngBounds(),
            myMap: false,
         };

        //this.setEstablishmentCollection = props.setEstablishmentCollection;
        this.refreshThisMap = this.refreshThisMap.bind(this);
        //this.handleBake = this.handleBake.bind(this);
    }

    componentDidUpdate( props, prevState ) {
        
        if( props.filterFrom == 'user' ){
            this.actualiseBounds(props)
        }
    }
    componentDidMount( props ){
        //console.log('componentDidMount method is called');
        //console.log( props )
    }

    // mets à jour le positionement de la carte
    actualiseBounds = ( props ) => {
        //console.log( 'actualiseBounds' )
        // reinitialize bounds
        let tempBounds = new props.google.maps.LatLngBounds()
        
        // new bounds
        this.state.filtredEstablishments.map((etab, index) => {
            if (!isNaN( parseFloat(etab.latitude) ) && !isNaN( parseFloat(etab.longitude)) && etab?.display == true ) {
                let point = { lat: parseFloat(etab.latitude), lng: parseFloat(etab.longitude) }
                tempBounds.extend(point);
            }
            else{
                etab.display = false
            }
        })
        if( !tempBounds.isEmpty() ){
            this.state.myMap.fitBounds( tempBounds );
            if( this.state.myMap.getZoom() > 12 ){
                this.state.myMap.setZoom(12)
            }
        }
        
    }

    // insert les marker sur la carte
    displayMarkers = () => {
        return this.state.filtredEstablishments.map((etab, index) => {
            if (!isNaN( parseFloat(etab.latitude) ) && !isNaN( parseFloat(etab.longitude) ) && (etab?.testEstablishment != "oui" || etab?.organizationId == 2113) ) {

                let point = { lat: parseFloat(etab.latitude), lng: parseFloat(etab.longitude) }
                this.state.myBounds.extend(point);

                return <Marker 
                    key={etab.id} id={etab.id} 
                    position={{
                        lat: etab.latitude,
                        lng: etab.longitude
                    }}
                    name={etab.name}
                    //onClick={this.onMarkerClick}
                    onClick={ ( props, marker ) =>  this.onMarkerClick(this.state, props) }
                    //onMouseover={}
                    title={ etab.city }
                    //Animation={this.state.google.maps.Animation.BOUNCE}
                />
            }
        })

        
    }
    onMarkerClick = (state, props ) => {
        //console.log(props);
        // Re centre la map sur le point clické
        let tempBounds = new props.google.maps.LatLngBounds()
        let lat = parseFloat(props.position.lat);
        let lng = parseFloat(props.position.lng);

        tempBounds.extend({ lat: lat, lng: lng } );

        if( !tempBounds.isEmpty() ){
            //let newCenter = this.state.myMap.getCenter(tempBounds)
            //this.state.myMap.panTo(newCenter)
            this.state.myMap.fitBounds( tempBounds )
            if( this.state.myMap.getZoom() > 12 ){
                this.state.myMap.setZoom(12)
            }
        }

        this.refreshThisMap( state, props.map )
    }
        
    onMapClicked = (props) => {
        //console.log( 'onReady' )
    }
    zoom_changed(state, map) {
        //console.log( 'zoom_changed' )

        this.refreshThisMap( state, map )
    }
    dragend( state, map) {
        //console.log( 'dragend' )
        this.refreshThisMap( state, map )
    }

    fetchPlaces(myBounds, map) {
        //console.log( 'onReady' )
        map.fitBounds( myBounds );
        this.setState({
            myMap: map
        })
    }

    refreshThisMap( state, map ){
        //console.log( 'refreshMap' )
        // get new bounds
        let mapBounds = map.getBounds()
        let hasChange = false
        // set display etab
        state.filtredEstablishments.map((etab, index) => {
            if (!isNaN( parseFloat(etab.latitude) ) && !isNaN( parseFloat(etab.longitude)) ) {
                let point = { lat: parseFloat(etab.latitude), lng: parseFloat(etab.longitude) }
                
                if (etab?.display != mapBounds.contains(point)) {
                    etab.display = mapBounds.contains(point)
                    hasChange = true
                }
            }
            else{
                etab.display = false
            }
        })
        if (hasChange) {
            this.props.refreshMap(state.filtredEstablishments);
        }
        
    }

    onChange(){
        //console.log( 'onChange' )
    }
    centerChanged(){
        //console.log( 'centerChanged' )
    }
    centerMoved(){
        //console.log( 'centerMoved' )
    }
    BoundsChanged(){
        //console.log( 'BoundsChanged' )
    }

  render() {
    //console.log('render method is called');
    return (
      <div className="mapEtab" id="mapEtabMulti">

        <Map 
            //ref={(map) => this._map = map}
            //ref={(map) => { console.log(map); map.fitBounds(this.state.myBounds); }}
            google={this.props.google}
            style={style}
            containerStyle={containerStyle}
            initialCenter={{
                lat: 42.39,
                lng: -72.52
            }}
            bounds={this.state.myBounds}

            // EVENTS
            //onDragend={ this.dragend }
            onDragend={ ( mapProps, map ) =>  this.dragend(this.state, map) }
            //onBoundsChanged={ this.BoundsChanged }
            //onZoomChanged={ this.zoom_changed }
            onZoomChanged={ ( mapProps, map ) =>  this.zoom_changed(this.state, map) }
            //onChange={ this.onChange }
            //onCenterChanged={ this.centerChanged }
            //onRecenter={ this.centerMoved }

            onReady={ ( mapProps, map ) =>  this.fetchPlaces(this.state.myBounds, map) }

            //zoom={10}
            //onClick={ this.onMapClicked }
            
            mapTypeControl = {false}
            streetViewControl = {false}
        >
          
            {this.displayMarkers()}
            {/*this.props.google.maps.fitBounds(this.state.myBounds)*/}
        </Map>
      </div>
    );
  }
}


export default GoogleApiWrapper({
  apiKey: (config.Gmap.KEY),
})(MapContainer)
/*const mapStateToProps = state => ({
    globalEstablishmentCollection: state.establishmentCollection.establishmentCollection,
})

const mapDispatchToProps = dispatch => ({
    setEstablishmentCollection: dispatch.establishmentCollection.updateEstablishment,
})

export default GoogleApiWrapper({
    apiKey: (config.Gmap.KEY),
})(connect(mapStateToProps, mapDispatchToProps)(MapContainer));*/